import { ReactComponent as ArrowBackSvg } from '../../assets/icons/arrow-back.svg';

export const ArrowBackIcon: SvgIcon = (props) => {
    return <ArrowBackSvg {...props} />;
};
